import {useDispatch, useSelector} from 'react-redux';
import {
  handleCurrentStep,
  selectSelectedBanData,
  selectPaymentAmount,
  selectPaymentFloors,
  selectPaymentAction,
  selectPaymentMethodBans,
  selectEpiData,
  selectBitReturnEvent,
  setSelectedBansForPaymentUpdate,
  setShowPopup,
  setSendPayment,
} from '../DebtAndUpdatePaymentBlockSlice';
import {validateHandler} from '../../SaleBlock/PaymentCG/PaymentCGSlice';
export const useDebtPaymentCreditCard = () => {
  const dispatch = useDispatch();

  const selectedBanData = useSelector(selectSelectedBanData);
  const paymentAmount = useSelector(selectPaymentAmount);
  const paymentFloorData = useSelector(selectPaymentFloors);
  const paymentActionType = useSelector(selectPaymentAction);
  const paymentMethodBans = useSelector(selectPaymentMethodBans);
  const epiData = useSelector(selectEpiData);
  const bitReturnEvent = useSelector(selectBitReturnEvent);
  const bitIsReady = useSelector((state) => state.bitPayment.isReady);
  const ccToken = useSelector((state) => state.PaymentCG.CCToken);
  const payment = useSelector((state) => state.PaymentCG);
  const creditCardError = useSelector((state) => state.PaymentCG.form.errorObj);
  const emvStep2CompletedSuccessfully = useSelector((state) => state.PaymentCG.emvStep2CompletedSuccessfully);
  const actions = {
    goToStep: (step) => dispatch(handleCurrentStep(step)),
    setShowPopup: (popup) => dispatch(setShowPopup(popup)),
    setSelectedBansForPaymentUpdate: (value) => dispatch(setSelectedBansForPaymentUpdate(value)),
    setSendPayment: () => dispatch(setSendPayment()),
    validatePaymentCG: (form) => dispatch(validateHandler(form)),
  };

  return {
    selectedBanData,
    paymentAmount,
    paymentActionType,
    paymentFloorData,
    paymentMethodBans,
    payingEntityLink: epiData?.payingEntityLink,
    bitReturnEvent,
    bitIsReady,
    ccToken,
    payment,
    creditCardError,
    emvStep2CompletedSuccessfully,
    actions,
  };
};
